<template>
  <div class="help">
    <page-header title="Часто задаваемые вопросы" />
    <div class="public-container public-container-mobile flex flex-space-between flex-align-items-start help-container">
      <div class="help-wrapper" itemscope="" itemtype="https://schema.org/QAPage">
        <h2>{{ title }}</h2>
        <help-content :mode="mode" class="only-desktop" />
        <vz-switcher-accordion
          v-model="mode"
          :items="modes"
          public-style
          class="help-switcher only-mobile"
        >
          <help-content :mode="mode" />
        </vz-switcher-accordion>
      </div>
      <vz-switcher
        v-model="mode"
        :items="modes"
        public-style
        class="help-switcher only-desktop"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import PageHeader from '~~/components/public/page-header.vue'
import VzSwitcherAccordion from '~~/components/ui-kit/vz-switcher-accordion.vue'
import HelpContent from '~~/components/public/help/help-content.vue'

const mode = ref('corporate')
const modes = [
  {
    title: 'Юридическим лицам',
    value: 'corporate'
  },
  {
    title: 'Физическим лицам',
    value: 'individual'
  }
]

const title = computed(() => {
  return modes.find((item) => item.value === mode.value)?.title || ''
})
</script>